import React from 'react';
import { useIntl } from 'react-intl';

import { CampaignPerformanceTotals } from 'apis/merchant-gateway/insights/campaigns-performance/types';

import { CampaignAnalyticsDateRageFilter } from './CampaignAnalyticsDateRageFilter';
import { CampaignAnalyticsMetrics } from './CampaignAnalyticsMetrics';
import { useCampaignModuleContext } from '../../context';
import { DateRange } from '../../types';

export const CampaignListMetrics = ({
  campaignPerformance,
  isLoading,
  dateRange,
  setDateRange,
}: {
  campaignPerformance?: CampaignPerformanceTotals;
  isLoading?: boolean;
  dateRange: DateRange;
  setDateRange: (dateRange: DateRange) => void;
}) => {
  const { formatMessage } = useIntl();
  const { currency, entityType } = useCampaignModuleContext();

  const {
    totalOrders,
    avgBasketValue,
    avgBasketSize,
    totalSpend,
    returningCustomers,
    newCustomers,
    totalSales,
    avgCostPerOrder,
  } = campaignPerformance ?? {};

  return (
    <CampaignAnalyticsMetrics
      currency={currency}
      title={formatMessage({ id: 'campaigns.analytics.campaign-performance' })}
      headerAction={<CampaignAnalyticsDateRageFilter onUpdate={setDateRange} dateRange={dateRange} />}
      colored
      isLoading={isLoading}
      metrics={{
        totalSales: totalSales ?? 0,
        totalSpend: totalSpend ?? 0,
        totalOrders: totalOrders ?? 0,
        averageBasketValue: avgBasketValue ?? 0,
        averageBasketItemsCount: avgBasketSize ?? 0,
        averageCostPerOrder: avgCostPerOrder ?? 0,
        ...(entityType === 'venue' || newCustomers != null ? { newCustomers: newCustomers ?? 0 } : {}),
        ...(entityType === 'venue' || returningCustomers != null
          ? { returningCustomers: returningCustomers ?? 0 }
          : {}),
      }}
      isSingleCampaign
    />
  );
};
